import type { PreviaMensalProps } from "./types-previa-mensal";
import { PreviaMensalView } from "./view-previa-mensal";

export function PreviaMensal(props: PreviaMensalProps) {
  return <PreviaMensalView {...props} />;
}

export type * from "./types-previa-mensal";
